import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconCalendar = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#818181",
		d: "M7.5 9.166H5.833v1.667H7.5V9.166zm3.333 0H9.167v1.667h1.666V9.166zm3.334 0H12.5v1.667h1.667V9.166zm1.666-5.833H15V1.666h-1.667v1.667H6.667V1.666H5v1.667h-.833c-.925 0-1.659.75-1.659 1.667L2.5 16.666c0 .917.742 1.667 1.667 1.667h11.666c.917 0 1.667-.75 1.667-1.666V5c0-.917-.75-1.667-1.667-1.667zm0 13.334H4.167V7.5h11.666v9.166z"
	})
});
export default SvgIconCalendar;
